import React, {useEffect, useRef, useState} from "react";
import {useDataWithRoute, useTitleFromComponent} from "../../utils/hooks";
import {VsiBubble, VsiH4, VsiHr} from "../../styled/App.styled";
import Grid from "../../components/Grid";
import {allDevicesAllClientsDefs} from "../../utils/gridColumnDefs/admin/allDevicesAllClients";
import {GetAuth} from "../../utils/Verbs";
import {useVsiAppContext} from "../../stores/VsiApp";

export default function AllDevicesAllClients({title}) {
    useTitleFromComponent(title);
    const { user, getAccessTokenSilently } = useVsiAppContext();
    const [nameIdMap, setNameIdMap] = useState({})
    const [chartData, setChartData] = useState([]);
    const [dbData, {isLoading}] = useDataWithRoute(`/api/v6/report/device_all_clients_proc`);

    useEffect(() => {
        const dbDevicesClients = dbData.recordset
        if (dbDevicesClients.length && nameIdMap) {
            // only start matching when both ready
            const updatedDataList = dbDevicesClients.map(item => (
                {...item, 'client_name': nameIdMap?.[item.client_id] || ''}
            ));
            setChartData(updatedDataList)
        }
    }, [dbData, nameIdMap]);

    useEffect(() => {
        const loadClientsList = async () => {
            try {
                const token = await getAccessTokenSilently();
                const activeClients = await GetAuth('/api/v6/admin/active_clients', token);
                let map = {};
                activeClients.data.forEach(item => {
                    map[item.clientId] = item.name;
                });
                setNameIdMap(map)
            } catch (e) {
                console.error('Failed to retrieve');
            }
        }
        loadClientsList();
    }, [])


    return (
        <div>
            <VsiH4>All Devices / All Clients</VsiH4>
            <VsiHr/>
            <VsiBubble>
                <Grid
                    data={chartData}
                    columnDefs={allDevicesAllClientsDefs}
                    isLoading={isLoading}
                />
            </VsiBubble>

        </div>
    )
}

